import { useState, useEffect, useRef, useCallback } from 'react';
import { set, get } from 'idb-keyval';


function useInterval(callback, delay) {

    const savedCallback = useRef();

    // remember the latest callback
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // set up interval
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);

}

//https://blog.johnnyreilly.com/2020/03/offline-storage-in-pwa.html
//also, https://github.com/brandonpittman/use-idb-keyval for the Non-TS fix
//Custom hook for use with idb-keyval
//keyToPersistWith = string, name to use for the IDB key
//defaultState = initial value to pass for the collection
function usePersistedState(keyToPersistWith, defaultState) {
    const [state, setState] = useState(defaultState);

    useEffect(() => {
        //console.log("in custom useEffect for idb-keyval with key: ", keyToPersistWith);
        get(keyToPersistWith)
            .then((value) => value === undefined || setState(value));
    }, [keyToPersistWith]);

    const setPersistedValue = useCallback((newValue) => {
        setState(newValue);
        set(keyToPersistWith, newValue);
    }, [keyToPersistWith, setState]);

    return [state, setPersistedValue];
}


//https://www.debuggr.io/react-update-unmounted-component/

function useIsMountedRef() {
    const isMountedRef = useRef(null);
    useEffect(() => {
        isMountedRef.current = true;
        return () => isMountedRef.current = false;
    });
    return isMountedRef;

}



export { useInterval, usePersistedState, useIsMountedRef };